import type {ISourceOptions} from 'tsparticles-engine';

import bg from './bg.jpg';

const lineBg: ISourceOptions = {
	fullScreen: {
		enable: true,
		zIndex: 1,
	},
	particles: {
		number: {
			value: 70,
			density: {
				enable: true,
				value_area: 800,
			},
		},
		color: {
			value: '#ffffff',
		},
		shape: {
			type: 'circle',
		},
		opacity: {
			value: 0.5,
			random: false,
			anim: {
				enable: false,
				speed: 1,
				opacity_min: 0.1,
				sync: false,
			},
		},
		size: {
			value: 2,
			random: true,
			anim: {
				enable: false,
				speed: 40,
				size_min: 0.1,
				sync: false,
			},
		},
		line_linked: {
			enable: true,
			distance: 150,
			color: '#ffffff',
			opacity: 0.4,
			width: 1,
		},
		move: {
			enable: true,
			speed: 0.2,
			direction: 'none',
			random: false,
			straight: false,
			out_mode: 'out',
			attract: {
				enable: false,
				rotateX: 600,
				rotateY: 1200,
			},
		},
	},
	interactivity: {
		events: {
			onhover: {
				// enable: true,
				// mode: 'slow', // bubble, repulse
				// parallax: {
				// 	enable: false,
				// 	force: 60,
				// 	smooth: 10,
				// },
				enable: true,
				mode: 'bubble',
				parallax: {
					enable: false,
					force: 2,
					smooth: 1,
				},
			},
			// onclick: {
			// 	enable: true,
			// 	mode: 'push',
			// },
			resize: true,
		},
		modes: {
			grab: {
				distance: 400,
				line_linked: {
					opacity: 1,
				},
			},
			bubble: {
				distance: 400,
				size: 5, // размер шаров
				duration: 2,
				opacity: 0.8,
				// speed: 3,
			},
			repulse: {
				distance: 200,
			},
			push: {
				particles_nb: 4,
			},
			remove: {
				particles_nb: 2,
			},
			slow: {
				radius: 100,
				factor: 3,
			},
		},
	},
	autoPlay: true,
	retina_detect: true,
	background: {
		color: {
			value: '#ffffff',
		},
		image: `url(${bg})`,
		position: '50% 50%',
		repeat: 'no-repeat',
		size: 'cover',
	},
};

export default lineBg;
